import { Injectable, Injector } from '@angular/core';
import { isObject, isString } from 'util';

@Injectable({
  providedIn: 'root'
})

export class FormFieldsTrimer {

  // Method for all screen except Shipment info screen
  trimFormfieldsData(obj){
    var keys = Object.keys(obj);
    for(var i=0; i< keys.length; i++ ) {
      if(obj[keys[i]]!=null){
        obj[keys[i]]=obj[keys[i]].toString().trim();
      }
    }
    return obj;
  }

  deleteempty(obj){
    var keys = Object.keys(obj);
    for(var i=0; i< keys.length; i++ ) {
      if(obj[keys[i]]!=null){
        obj[keys[i]]=obj[keys[i]].toString().trim();
      }else{
        console.log(obj[i])
        //delete obj[keys[i]]
      }
    }
    return obj;
  }

  // removeEmpty = (obj) => {
  //   Object.keys(obj).forEach(k =>
  //     (obj[k] && typeof obj[k] === "object") && this.removeEmpty(obj[k]) ||
  //     (!obj[k] && obj[k] !== undefined) && delete obj[k]
  //   );
  //   return obj;
  // };

  clean(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    for (var i = 0; i < propNames.length; i++) {
      var propName = propNames[i];
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
        delete obj[propName];
      }
    }
    return obj;
  }
}